import { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { min, sum } from 'lib/arrayUtils'
import createSelector from 'lib/createSelector'
import { getSelectableOccupancies, getSelectedDepartureOccupanciesOptions } from 'selectors/TourV2/tourV2OfferPageDeparturesSelectors'
import { TourV2RoomSelectionState } from './tourV2RoomSelectionState'

export const getOccupanciesTotalPrice = createSelector(
  (roomSelectionState: TourV2RoomSelectionState) => roomSelectionState.selectedPurchasableOptions,
  (_roomSelectionState: TourV2RoomSelectionState, offerPageState: OfferPageState) => getSelectedDepartureOccupanciesOptions(offerPageState),
  (
    selectedPurchasableOptions,
    occupanciesOptions,
  ) => sum(
    Array.from(occupanciesOptions.entries())
      .map(([occupants, options]) => {
        // check if a purchasable option is selected for the occupants
        if (selectedPurchasableOptions.has(occupants)) {
          const selectedPurchasableOption = selectedPurchasableOptions.get(occupants)
          if (!selectedPurchasableOption) { return 0 }

          const optionPriceBreakdown = options.get(selectedPurchasableOption)
          return optionPriceBreakdown?.totalPrice ?? 0
        } else { // use the cheapest price
          const cheapestPriceBreakdown = min(
            Array.from(options.values()),
            (priceBreakdown) => priceBreakdown.totalPrice,
          )

          return cheapestPriceBreakdown?.totalPrice ?? 0
        }
      }),
  ),
)

export const getHasAllOccupanciesOptionsSelected = createSelector(
  (roomSelectionState: TourV2RoomSelectionState) => roomSelectionState.selectedPurchasableOptions,
  (_roomSelectionState: TourV2RoomSelectionState, offerPageState: OfferPageState) => getSelectableOccupancies(offerPageState),
  (
    selectedPurchasableOptions,
    selectableOccupancies,
  ): boolean => selectableOccupancies.length > 0 &&
  selectedPurchasableOptions.size > 0 &&
    selectableOccupancies.every(occupants => !!selectedPurchasableOptions.get(occupants)),
)
